import { npcLogConstant } from 'src/redux/actions/constant';

const initialState = { response: null, isAddNpcEntry: false, loading: false };

export const addNpcEntryReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case npcLogConstant.ADD_NPC_ENTRY_SUCCESS:
      return { ...state, isAddNpcEntry: true, response: action.payload, loading: false };
    case npcLogConstant.ADD_NPC_ENTRY_FAILURE:
      return { ...state, isAddNpcEntry: false, response: action.payload, loading: false };
    case npcLogConstant.ADD_NPC_ENTRY_LOADER:
      return { ...state, loading: true };
    case npcLogConstant.ADD_NPC_ENTRY_RESET:
      return initialState;
    default:
      return state;
  }
};
